export default function ComplianceQueue({ children }) {
  return (
    <div
      style={{
        padding: 16,
        borderRadius: 20,
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        boxShadow: "0 10px 30px rgba(15,23,42,.06)",
      }}
    >
      <div style={{ fontSize: 16, fontWeight: 950, color: "#0f172a" }}>
        Worker Review Queue
      </div>

      <div style={{ marginTop: 12, display: "grid", gap: 10 }}>
        {children}
      </div>
    </div>
  );
}